const DEFAULT_LOCALE = "es-MX";

export const normalizeCollectionLocale = (locale) => {
  if (locale === "en-US") {
    return "en-US";
  }

  if (locale === "es-ES") {
    return "es-ES";
  }

  return DEFAULT_LOCALE;
};

export const COLLECTION_NAMING = {
  "es-MX": {
    muro: {
      title: "Muro",
      upperTitle: "MURO",
      designLabel: "loseta 3D de concreto",
      designPluralLabel: "losetas 3D de concreto",
    },
    celosias: {
      title: "Celosías",
      upperTitle: "CELOSÍAS",
      designLabel: "celosía de concreto",
      designPluralLabel: "celosías de concreto",
    },
    paneles: {
      title: "Paneles",
      upperTitle: "PANELES",
      designLabel: "panel de concreto arquitectónico",
      designPluralLabel: "paneles de concreto arquitectónico",
    },
    pisos: {
      title: "Pisos",
      upperTitle: "PISOS",
      designLabel: "loseta de concreto para piso",
      designPluralLabel: "losetas de concreto para piso",
    },
  },
  "es-ES": {
    muro: {
      title: "Muro",
      upperTitle: "MURO",
      designLabel: "loseta 3D de hormigón",
      designPluralLabel: "losetas 3D de hormigón",
    },
    celosias: {
      title: "Celosías",
      upperTitle: "CELOSÍAS",
      designLabel: "celosía de hormigón",
      designPluralLabel: "celosías de hormigón",
    },
    paneles: {
      title: "Paneles",
      upperTitle: "PANELES",
      designLabel: "panel de hormigón arquitectónico",
      designPluralLabel: "paneles de hormigón arquitectónico",
    },
    pisos: {
      title: "Pavimentos",
      upperTitle: "PAVIMENTOS",
      designLabel: "loseta de hormigón para suelo",
      designPluralLabel: "losetas de hormigón para suelo",
    },
  },
  "en-US": {
    muro: {
      title: "Concrete Wall Tiles",
      upperTitle: "CONCRETE WALL TILES",
      designLabel: "concrete wall tile",
      designPluralLabel: "concrete wall tiles",
    },
    celosias: {
      title: "Concrete Screens",
      upperTitle: "CONCRETE SCREENS",
      designLabel: "concrete screen",
      designPluralLabel: "concrete screens",
    },
    paneles: {
      title: "Decorative Concrete Panels",
      upperTitle: "DECORATIVE CONCRETE PANELS",
      designLabel: "decorative concrete panel",
      designPluralLabel: "decorative concrete panels",
    },
    pisos: {
      title: "Concrete Floor Tiles",
      upperTitle: "CONCRETE FLOOR TILES",
      designLabel: "concrete floor tile",
      designPluralLabel: "concrete floor tiles",
    },
  },
};

export const getCollectionNaming = (locale, collectionId) => {
  const safeLocale = normalizeCollectionLocale(locale);
  const localeMap = COLLECTION_NAMING[safeLocale] || COLLECTION_NAMING[DEFAULT_LOCALE];
  const fallbackMap = COLLECTION_NAMING[DEFAULT_LOCALE];

  return localeMap?.[collectionId] || fallbackMap?.[collectionId] || {
    title: collectionId,
    upperTitle: collectionId?.toUpperCase?.() || collectionId,
    designLabel: collectionId,
    designPluralLabel: collectionId,
  };
};

export const getCollectionLabels = (locale) => {
  const safeLocale = normalizeCollectionLocale(locale);
  const localeMap = COLLECTION_NAMING[safeLocale] || COLLECTION_NAMING[DEFAULT_LOCALE];

  return Object.fromEntries(Object.entries(localeMap).map(([collectionId, naming]) => [collectionId, naming.title]));
};